// extracted by mini-css-extract-plugin
export default {"root":"DestructiveDialog_root__k6I94","content":"DestructiveDialog_content__MalcM","actions":"DestructiveDialog_actions__G9ZGo","button":"DestructiveDialog_button__PJS-r"};